import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[membershipDetailDirective]',
})
export class MembershipDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}